// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { postalCodeValidation } from "@hardwoods/XDL/Utilities/validation";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    chain,
    ValidatePhone,
    ValidatePostalCode,
} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";

const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4,5})$/;

const isEmpty = (value: string) => value.trim().length <= 0;
const isValidPhoneNumber = (value: string) => phoneRegex.test(value);

export const XngValidatePhone: any = (props: any) => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { phone } = props.parameter.address;
    if (addressFieldDisplayCollection.phone?.isVisible && validationRules.phone?.isRequired && isEmpty(phone)) {
        props.addressErrors.phone = siteMessage("Field_Required", addressFieldDisplayCollection.phone.displayName);
    } else if (!isEmpty(phone) && !isValidPhoneNumber(phone)) {
        props.addressErrors.phone = siteMessage("AddressInfo_Phone_Validation");
    }
};

export const XngValidatePostalCode: any = (props: any) => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { postalCode } = props.parameter.address;
    if (
        addressFieldDisplayCollection.postalCode?.isVisible &&
        validationRules.postalCode?.isRequired &&
        isEmpty(postalCode)
    ) {
        props.addressErrors.postalCode = siteMessage(
            "Field_Required",
            addressFieldDisplayCollection.postalCode.displayName,
        );
    } else if (!isEmpty(postalCode) && !postalCodeValidation(postalCode)) {
        props.addressErrors.postalCode = siteMessage("AddressInfo_PostalCode_Validation");
    }
};

replaceInChain(chain, ValidatePhone, XngValidatePhone);
replaceInChain(chain, ValidatePostalCode, XngValidatePostalCode);
